import React, { useState, useEffect } from 'react';
import { makeStyles, ThemeProvider as CoreThemeProvider, createMuiTheme as createCoreTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from '@mui/material/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { useHistory } from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import api from '../../../../../services/api';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { format, addDays, isValid, parse } from 'date-fns';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useParams } from "react-router-dom";
import {
    Card,
    CardContent,
    IconButton,
    Divider
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import { ptBR } from "date-fns/locale";

export default function ComponentAgendamento({ flag, idAgendamento, agendamento }) {

    const [darkMode, setDarkMode] = useState(() => {
        const saved = Cookies.get('darkMode') || Cookies.get('tema');
        return saved === 'true' || saved === 'dark';
    });

    useEffect(() => {
        const checkDarkMode = () => {
            const saved = Cookies.get('darkMode') || Cookies.get('tema');
            setDarkMode(saved === 'true' || saved === 'dark');
        };

        window.addEventListener('darkModeChanged', checkDarkMode);
        window.addEventListener('temaChanged', checkDarkMode);
        window.addEventListener('focus', checkDarkMode);

        return () => {
            window.removeEventListener('darkModeChanged', checkDarkMode);
            window.removeEventListener('temaChanged', checkDarkMode);
            window.removeEventListener('focus', checkDarkMode);
        };
    }, []);

    const themeV5 = React.useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            }
        },
    }), [darkMode]);

    const themeV4 = React.useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            background: {
                default: darkMode ? '#121212' : '#ffffff',
                paper: darkMode ? '#1e1e1e' : '#ffffff',
            },
            text: {
                primary: darkMode ? '#ffffff' : '#000000',
                secondary: darkMode ? '#aaaaaa' : '#666666',
            }
        },
        overrides: {
            MuiTextField: {
                root: darkMode ? {
                    '& label.Mui-focused': { color: 'white' },
                    '& label': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'white' },
                        '&:hover fieldset': { borderColor: 'white' },
                        '&.Mui-focused fieldset': { borderColor: 'white' },
                    },
                } : {},
            },
            MuiFormLabel: {
                root: darkMode ? {
                    color: 'white',
                    '&$focused': {
                        color: 'white'
                    }
                } : {}
            },
            MuiInputBase: {
                input: darkMode ? {
                    color: 'white',
                } : {}
            },
            MuiAutocomplete: {
                root: darkMode ? {
                    '& .MuiInputLabel-root': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                } : {},
                popupIndicator: darkMode ? {
                    color: 'white'
                } : {},
                clearIndicator: darkMode ? {
                    color: 'white'
                } : {},
                paper: darkMode ? {
                    backgroundColor: '#1e1e1e',
                    color: 'white'
                } : {}
            },
            MuiCard: {
                root: darkMode ? {
                    backgroundColor: '#1e1e1e',
                    color: 'white',
                    borderColor: '#333',
                } : {}
            },
            MuiDialog: {
                paper: darkMode ? {
                    backgroundColor: '#1e1e1e',
                    color: 'white'
                } : {}
            },
            MuiTypography: {
                colorTextSecondary: darkMode ? {
                    color: '#aaaaaa'
                } : {}
            }
        },
    }), [darkMode]);

    const [loading, setLoading] = useState(true);


    const history = useHistory();

    const [descricao, setDescricao] = useState('');


    const [colaboradores, setColaboradores] = useState([]);
    const [colaboradoresSelecionados, setColaboradoresSelecionados] = useState([]);


    const [tipoAgendamento, setTipoAgendamento] = useState(0);

    const handleChangeTipo = (event) => {
        setTipoAgendamento(event.target.value);
    };


    const { idOrdemServico } = useParams();
    const { idProcedimentoExecucao } = useParams();
    const { tipoCadastro } = useParams();


    const [equipes, setEquipes] = useState([]);
    const [equipeSelecionada, setEquipeSelecionada] = useState(null);
    function handleSetEquipe(equipe) {
        setEquipeSelecionada(equipe);
    }

    const [veiculos, setVeiculos] = useState([]);
    const [veiculoSelecionado, setVeiculoSelecionado] = useState(null);

    function handleSetVeiculo(veiculo) {
        setVeiculoSelecionado(veiculo);
    }


    const [controleSelecao, setControleSelecao] = useState(false);


    const [motivo, setMotivo] = useState('');

    const [dataInicial, setDataInicial] = useState(format(new Date(), 'dd/MM/yyyy'));
    const [horaInicial, setHoraInicial] = useState("08:00");
    const [dataFinal, setDataFinal] = useState(format(addDays(new Date(), 7), 'dd/MM/yyyy'));
    const [horaFinal, setHoraFinal] = useState("12:00");

    const [botaoSalvarClickado, setBotaoSalvarClickado] = useState(false);






    async function listarInformacoes() {

        console.log("listando infos");
        setLoading(true);

        try {

            try {

                const parsedHoraInicial = parse(horaInicial, 'HH:mm', new Date());
                if (!isValid(parsedHoraInicial)) {
                    alert("Hora Inicial Inválida!");
                    return null;
                }

                const parsedDataInicial = parse(dataInicial, 'dd/MM/yyyy', new Date());
                if (!isValid(parsedDataInicial)) {
                    alert("Data Inicial Inválida!");
                    return null;
                }

                const parsedHoraFinal = parse(horaFinal, 'HH:mm', new Date());
                if (!isValid(parsedHoraFinal)) {
                    alert("Hora Final Inválida!");
                    return null;
                }

                const parsedDataFinal = parse(dataFinal, 'dd/MM/yyyy', new Date());
                if (!isValid(parsedDataFinal)) {
                    alert("Data Final Inválida!");
                    return null;
                }

                // Formatar datas e horas para 'yyyy/MM/dd HH:mm'
                var dataHoraInicialFormatada = format(parsedDataInicial, 'yyyy-MM-dd') + ' ' + format(parsedHoraInicial, 'HH:mm');
                var dataHoraFinalFormatada = format(parsedDataFinal, 'yyyy-MM-dd') + ' ' + format(parsedHoraFinal, 'HH:mm');


                const token = Cookies.get('token');

                const headers = {
                    'Authorization': 'Bearer ' + token
                }

                console.log("listando infos 2");

                await api.get("v1/protected/agendamentos/veiculos/" + dataHoraInicialFormatada + "/" + dataHoraFinalFormatada, {
                    headers: headers
                }).then(function (response) {

                    console.log("retorno");

                    console.log("veiculos: " + JSON.stringify(response.data));
                    setVeiculos(response.data)


                    api.get("/v1/protected/colaboradores/listartodos", {
                        headers: headers
                    }).then(function (response) {
                        setColaboradores(response.data)

                        if (flag === 1) {

                            api.get("v1/protected/agendamentos/listarporid/" + idAgendamento, {
                                headers: headers
                            }).then(function (response) {

                                setTipoAgendamento(response.data.tipo_agendamento)
                                setMotivo(response.data.motivo);
                                setVeiculoSelecionado(response.data.veiculo);
                                setDescricao(response.data.descricao_agendamento);


                                // Recebe strings no formato SQL: "YYYY-MM-DD HH:mm:ss"
                                const dataHoraInicialRaw = response.data.data_hora_inicial;
                                const dataHoraFinalRaw = response.data.data_hora_final;

                                // 🔹 Converte para objeto Date
                                const dataHoraInicialObj = new Date(dataHoraInicialRaw.replace(" ", "T"));
                                const dataHoraFinalObj = new Date(dataHoraFinalRaw.replace(" ", "T"));

                                // 🔹 Formata e separa em data e hora
                                setDataInicial(format(dataHoraInicialObj, "dd/MM/yyyy", { locale: ptBR }));
                                setHoraInicial(format(dataHoraInicialObj, "HH:mm", { locale: ptBR }));

                                setDataFinal(format(dataHoraFinalObj, "dd/MM/yyyy", { locale: ptBR }));
                                setHoraFinal(format(dataHoraFinalObj, "HH:mm", { locale: ptBR }));


                                setColaboradoresSelecionados(response.data.colaboradores)

                                setLoading(false);

                            });

                        } else {
                            setLoading(false);

                        }
                    });











                });


            } catch (_err) {
                // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
                console.log("Erro ao listar veículos: " + _err)

            }

        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar equipes: " + _err)

        }

    }

    useEffect(() => {

        if (flag === 1 || flag === 0)
            listarInformacoes();
        else if (flag === 2) {

            setVeiculoSelecionado(agendamento.veiculo);
            setMotivo(agendamento.motivo);
            setDescricao(agendamento.descricao_agendamento);
            setTipoAgendamento(agendamento.tipo_agendamento);
            setColaboradoresSelecionados(agendamento.colaboradores)


            // Recebe strings no formato SQL: "YYYY-MM-DD HH:mm:ss"
            const dataHoraInicialRaw = agendamento.data_hora_inicial;
            const dataHoraFinalRaw = agendamento.data_hora_final;

            // 🔹 Converte para objeto Date
            const dataHoraInicialObj = new Date(dataHoraInicialRaw.replace(" ", "T"));
            const dataHoraFinalObj = new Date(dataHoraFinalRaw.replace(" ", "T"));

            // 🔹 Formata e separa em data e hora
            setDataInicial(format(dataHoraInicialObj, "dd/MM/yyyy", { locale: ptBR }));
            setHoraInicial(format(dataHoraInicialObj, "HH:mm", { locale: ptBR }));

            setDataFinal(format(dataHoraFinalObj, "dd/MM/yyyy", { locale: ptBR }));
            setHoraFinal(format(dataHoraFinalObj, "HH:mm", { locale: ptBR }));



            setLoading(false);
        }

    }, []);







    const handleSetColaboradoresSelecionados = (event, values) => {
        if (Array.isArray(values)) {
            const novosColaboradoresSelecionados = values.filter(
                (colaborador) => !colaboradoresSelecionados.includes(colaborador)
            );
            setColaboradoresSelecionados(novosColaboradoresSelecionados);
        } else if (values !== null) {
            // Tratar caso values seja um objeto (único valor selecionado)
            if (!colaboradoresSelecionados.includes(values)) {
                setColaboradoresSelecionados([...colaboradoresSelecionados, values]);
            }
        } else {
            setColaboradoresSelecionados([]);
        }
    };


    const [openRemoverColaborador, setOpenRemoverColaborador] = useState(false);
    const [idAgendamentoColaboradorARemover, setIdAgendamentoColaboradorARemover] = useState(0);
    const [dataSaida, setDataSaida] = useState(null);
    const [motivoSaida, setMotivoSaida] = useState(null);

    const handleOpenRemoverColaborador = (id) => {
        setOpenRemoverColaborador(true);
        setIdAgendamentoColaboradorARemover(id)
    }

    const handleCloseRemoverColaborador = () => {
        setOpenRemoverColaborador(false);
        setIdAgendamentoColaboradorARemover(0);
        setMotivoSaida(null);
        setDataSaida(null);
    }



    async function removerColaborador() {


        try {

            if (!dataSaida) {
                alert("Informe a data de saída!");
                return null;
            }


            if (idAgendamentoColaboradorARemover <= 0) {
                return null;
            }
            console.log("cadastrar chamado");





            const cadastro = {
                motivo_saida: motivoSaida,
                data_saida: dataSaida,


            }

            console.log(JSON.stringify(cadastro));
            console.log("id remover: " + idAgendamentoColaboradorARemover);

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            let url = 'v1/protected/agendamentos/removercolaborador/' + idAgendamentoColaboradorARemover;



            const response = await api.put(url, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {


                alert("Atuaizado!");
                window.location.reload();



            } else {
                alert("Erro! Consulte o administrador do sistema");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }



    }




    function returnDescricaoStatus(col) {
        const status = col.status;

        if (status === 0) return "Trabalhando";
        if (status === 1) return "Finalizado";
        if (status === 9)
            return `Retirado antes do término em ${col.data_saida}`;

        return "";
    }


    function returnDescricaoColaborador(colaborador) {
        const col = colaborador.colaborador
            ? colaborador.colaborador
            : colaborador;

        return (
            <>
                <div><strong>ID:</strong> {col.id_colaborador}</div>
                <div><strong>CPF:</strong> {col.cpf}</div>
                <div><strong>Nome:</strong> {col.nome} {col.sobrenome}</div>



                <div style={{ marginTop: 8 }}>
                    <strong>Status no agendamento:</strong>{" "}
                    {returnDescricaoStatus(colaborador)}
                </div>
            </>
        );
    }


    function returnDescricaoColaborador2(colaborador) {

        let col;

        if (colaborador.colaborador) {
            col = colaborador.colaborador;
        } else {
            col = colaborador;
        }



        var texto = "  Colaborador_ID: " + col.id_colaborador +
            "\n CPF: " + col.cpf +
            "\n Nome: " + col.nome + " " + col.sobrenome;
        return texto;
    }


    async function salvar() {
        setBotaoSalvarClickado(true);


        try {

            if (!colaboradoresSelecionados || colaboradoresSelecionados.length <= 0) {
                alert("Selecione no mínimo 1 colaborador");
                setBotaoSalvarClickado(false);
                return null;
            }

            console.log("cadastrar chamado");
            const cadastro = {
                motivo: motivo,
                descricao: descricao,
                usuario_criador: { id_usuario: Cookies.get("id_usuario") },
                pessoas: colaboradoresSelecionados,

            }


            const parsedHoraInicial = parse(horaInicial, 'HH:mm', new Date());
            if (!isValid(parsedHoraInicial)) {
                alert("Hora Inicial Inválida!");
                setBotaoSalvarClickado(false);
                return null;
            }

            const parsedDataInicial = parse(dataInicial, 'dd/MM/yyyy', new Date());
            if (!isValid(parsedDataInicial)) {
                alert("Data Inicial Inválida!");
                setBotaoSalvarClickado(false);
                return null;
            }

            const parsedHoraFinal = parse(horaFinal, 'HH:mm', new Date());
            if (!isValid(parsedHoraFinal)) {
                alert("Hora Final Inválida!");
                setBotaoSalvarClickado(false);
                return null;
            }

            const parsedDataFinal = parse(dataFinal, 'dd/MM/yyyy', new Date());
            if (!isValid(parsedDataFinal)) {
                alert("Data Final Inválida!");
                setBotaoSalvarClickado(false);
                return null;
            }

            // Formatar datas e horas para 'yyyy/MM/dd HH:mm'
            var dataHoraInicialFormatada = format(parsedDataInicial, 'yyyy-MM-dd') + ' ' + format(parsedHoraInicial, 'HH:mm');
            var dataHoraFinalFormatada = format(parsedDataFinal, 'yyyy-MM-dd') + ' ' + format(parsedHoraFinal, 'HH:mm');

            cadastro.data_hora_inicial = dataHoraInicialFormatada;
            cadastro.data_hora_final = dataHoraFinalFormatada;

            if (!veiculoSelecionado) {
                alert("Selecione o Veículo!");
                setBotaoSalvarClickado(false);
                return null;
            } else {
                cadastro.veiculo = veiculoSelecionado;
            }



            if (parseInt(tipoCadastro) === 2) {
                cadastro.id_ordem_servico_associada = idOrdemServico;
            }


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            let url = '/v1/protected/agendamentos/cadastrar/';

            if (parseInt(tipoCadastro) >= 0) {
                //agendar veiculo para ordem de servico
                url += ("1/" + idOrdemServico + "/" + idProcedimentoExecucao);
            } else {
                url += ("0/0/0");

            }


            const response = await api.post(url, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {


                alert("Agendamento Cadastrado");
                if (parseInt(tipoCadastro) >= 0) {
                    // history.push({
                    //  pathname: "/gestao/administracao/ordensdeservicos/gerenciartratamentoemcampo/" + idOrdemServico,
                    //   })
                    // Tentar fechar a guia
                    setTimeout(() => {
                        window.close();
                    }, 100); // Pequeno atraso para garantir que a navegação seja iniciada
                } else {

                    history.push({
                        pathname: "/gestao/operacional/agendamentos/listar",
                    })
                }




            } else {
                alert("O escopo do agendamento conflita com agendamentos já cadastrados!");
                setBotaoSalvarClickado(false);
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setBotaoSalvarClickado(false);

        }



    }





    async function atualizar() {
        setBotaoSalvarClickado(true);


        try {




            const colaboradoresFiltrados = colaboradoresSelecionados.filter(
                c => !c.id_agendamento_colaborador
            );

            console.log("Col: " + JSON.stringify(colaboradoresFiltrados, null, 2));


            console.log("cadastrar chamado");
            const cadastro = {
                motivo: motivo,
                descricao: descricao,
                pessoas: colaboradoresFiltrados,

            }


            const parsedHoraInicial = parse(horaInicial, 'HH:mm', new Date());
            if (!isValid(parsedHoraInicial)) {
                alert("Hora Inicial Inválida!");
                setBotaoSalvarClickado(false);
                return null;
            }

            const parsedDataInicial = parse(dataInicial, 'dd/MM/yyyy', new Date());
            if (!isValid(parsedDataInicial)) {
                alert("Data Inicial Inválida!");
                setBotaoSalvarClickado(false);
                return null;
            }

            const parsedHoraFinal = parse(horaFinal, 'HH:mm', new Date());
            if (!isValid(parsedHoraFinal)) {
                alert("Hora Final Inválida!");
                setBotaoSalvarClickado(false);
                return null;
            }

            const parsedDataFinal = parse(dataFinal, 'dd/MM/yyyy', new Date());
            if (!isValid(parsedDataFinal)) {
                alert("Data Final Inválida!");
                setBotaoSalvarClickado(false);
                return null;
            }

            // Formatar datas e horas para 'yyyy/MM/dd HH:mm'
            var dataHoraInicialFormatada = format(parsedDataInicial, 'yyyy-MM-dd') + ' ' + format(parsedHoraInicial, 'HH:mm');
            var dataHoraFinalFormatada = format(parsedDataFinal, 'yyyy-MM-dd') + ' ' + format(parsedHoraFinal, 'HH:mm');

            cadastro.data_hora_inicial = dataHoraInicialFormatada;
            cadastro.data_hora_final = dataHoraFinalFormatada;


            if (tipoAgendamento === 0) {
                //veiculo
                if (!veiculoSelecionado) {
                    alert("Selecione o Veículo!");
                    setBotaoSalvarClickado(false);
                    return null;
                } else {
                    cadastro.veiculo = veiculoSelecionado;
                }
            } else if (tipoAgendamento === 1) {
                //equipe
                //veiculo


            } else if (tipoAgendamento === 2) {
                if (parseInt(tipoCadastro) === 2) {
                    cadastro.id_ordem_servico_associada = idOrdemServico;
                }
                //veiculo
                if (!veiculoSelecionado) {
                    alert("Selecione o Veículo!");
                    setBotaoSalvarClickado(false);
                    return null;
                } else {
                    cadastro.veiculo = veiculoSelecionado;
                }



            }


            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            let url = '/v1/protected/agendamentos/atualizar/' + idAgendamento;



            const response = await api.put(url, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {


                alert("Agendamento Atualizado!");
                if (parseInt(tipoCadastro) >= 0) {


                    setTimeout(() => {
                        window.close();
                    }, 100); // Pequeno atraso para garantir que a navegação seja iniciada
                } else {

                    window.location.reload();


                }

                setBotaoSalvarClickado(false);


            } else {
                alert("O escopo do agendamento conflita com agendamentos já cadastrados!");
                setBotaoSalvarClickado(false);
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setBotaoSalvarClickado(false);

        }



    }




    function returnDescricaoAgendamento(agendamento) {
        var texto = "ID:  " + agendamento.id_agendamento +
            "\nDe " + format(new Date(agendamento.data_hora_inicial), 'HH:mm dd/MM/yyyy') + " até " + format(new Date(agendamento.data_hora_final), 'HH:mm dd/MM/yyyy') +
            "\nMotivo: " + agendamento.motivo +
            "\nDescrição: " + agendamento.descricao;



        return texto;

    }





    function returnDescricaoVeiculo(veiculo) {


        var texto = "ID Veículo: " + veiculo.id_veiculo +
            "\nPlaca: " + veiculo.placa +
            " | " + veiculo.marca + " | " + veiculo.modelo;


        // Verifica se o veículo possui agendamentos
        if (veiculo.agendamentos && veiculo.agendamentos.length > 0) {
            texto += "\n\nAgendamentos:";
            veiculo.agendamentos.forEach((agendamento, index) => {
                texto += `\n\n  Agendamento ${index + 1}: ${returnDescricaoAgendamento(agendamento)}`;
            });
        } else {
            texto += "\nAgendamentos: Sem Agendamentos nos últimos 60 dias";
        }

        return texto;
    }



    return (
        <MuiThemeProvider theme={themeV5}>
            <CoreThemeProvider theme={themeV4}>
                <div style={{ backgroundColor: themeV5.palette.background.default, color: themeV5.palette.text.primary, minHeight: '100%', padding: '10px' }}>



                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={10}
                    >
                        {
                            flag === 0 &&
                            <Button style={{ marginTop: 5 }}
                                variant="contained"
                                color="primary"
                                onClick={salvar}
                                disabled={botaoSalvarClickado}
                            > Salvar  </Button>
                        }

                        {
                            flag === 1 &&
                            <Button style={{ marginTop: 5 }}
                                variant="contained"
                                color="primary"
                                onClick={atualizar}
                                disabled={botaoSalvarClickado}
                            > Atualizar  </Button>
                        }

                    </Grid>
                    {loading ?
                        <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                        </Skeleton>
                        :
                        <Grid
                            container
                            direction="row"
                            item xs={12}
                            alignItems="center"
                            justifyContent="center"
                            spacing={2}
                        >
                            <Grid
                                container
                                direction="row"
                                item xs={12}
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                            >


                                <Grid
                                    style={{ paddingTop: 30 }}
                                    container
                                    direction="row"
                                    item xs={12}
                                    alignItems="center"
                                    justifyContent="center"
                                    spacing={2}
                                >

                                    <Grid container spacing={2}>
                                        {colaboradoresSelecionados.length === 0 && (
                                            <Grid item xs={12}>
                                                <Typography color="text.secondary">
                                                    Nenhum colaborador selecionado
                                                </Typography>
                                            </Grid>
                                        )}
                                        <Grid item xs={12}>
                                            <Divider sx={{ mb: 2 }} />
                                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                👥 Colaboradores Vinculados
                                            </Typography>
                                        </Grid>
                                        {colaboradoresSelecionados.map((colaborador, index) => (
                                            <Grid item xs={12} sm={6} md={3} key={index}>
                                                <Card
                                                    elevation={0}
                                                    sx={{
                                                        height: "100%",
                                                        borderRadius: 3,
                                                        border: "1px solid",
                                                        borderColor: darkMode ? "#333" : "#e0e0e0",
                                                        backgroundColor: darkMode ? "#1e1e1e" : "#fff",
                                                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                                        transition: "0.2s",
                                                        "&:hover": {
                                                            boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
                                                            transform: "translateY(-2px)"
                                                        }
                                                    }}
                                                >
                                                    <CardContent>
                                                        <Grid
                                                            container
                                                            alignItems="center"
                                                            justifyContent="space-between"
                                                        >

                                                            <Grid item xs={10}>
                                                                <Typography style={{ whiteSpace: "pre-line" }}>
                                                                    {returnDescricaoColaborador(colaborador)}
                                                                </Typography>
                                                            </Grid>

                                                            {colaborador.status === 0 &&
                                                                (<Grid item xs={2} textAlign="right">
                                                                    <IconButton
                                                                        color="error"
                                                                        onClick={() =>
                                                                            handleOpenRemoverColaborador(
                                                                                colaborador.id_agendamento_colaborador
                                                                            )
                                                                        }
                                                                    >
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Grid>)
                                                            }

                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>

                                    {
                                        flag !== 2 &&
                                        (
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                align="center"
                                                item xs={12}
                                                style={{ marginTop: 5 }}
                                            >
                                                <Grid
                                                    container
                                                    direction="column"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={12}
                                                >
                                                    <Autocomplete
                                                        id="select-colaboradores"
                                                        options={colaboradores}
                                                        disableCloseOnSelect
                                                        getOptionLabel={(colaborador) => returnDescricaoColaborador2(colaborador).replace(/<br \/>/g, '\n')}
                                                        onChange={handleSetColaboradoresSelecionados}
                                                        filterOptions={(options, { inputValue }) => {
                                                            const inputKeywords = inputValue.toLowerCase().split(" ");
                                                            return options.filter((colaborador) => {
                                                                const colaboradorText = returnDescricaoColaborador2(colaborador).toLowerCase();
                                                                return inputKeywords.every((keyword) => colaboradorText.includes(keyword));
                                                            });
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label=" Colaboradores " multiline minRows={3} />
                                                        )}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )
                                    }


                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    item xs={12}
                                    alignItems="center"
                                    justifyContent="center"
                                    spacing={2}
                                >

                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        align="center"
                                        item xs={9}
                                    >
                                        <Card
                                            sx={{
                                                p: 2,
                                                borderRadius: 3,
                                                border: "1px solid",
                                                borderColor: darkMode ? "#333" : "#e0e0e0",
                                                backgroundColor: darkMode ? "#1e1e1e" : "#fff",
                                                boxShadow: "0 4px 10px rgba(0,0,0,0.08)"
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ mb: 1, color: darkMode ? '#fff' : 'inherit' }}>
                                                🚗 Veículo
                                            </Typography>
                                            <Autocomplete
                                                id="select-veiculo"
                                                options={veiculos}
                                                disableCloseOnSelect
                                                getOptionLabel={(veiculo) => returnDescricaoVeiculo(veiculo).replace(/<br \/>/g, '\n')}
                                                value={veiculoSelecionado}
                                                onChange={(e, v) => handleSetVeiculo(v)}
                                                filterOptions={(options, { inputValue }) => {
                                                    const inputKeywords = inputValue.toLowerCase().split(" ");
                                                    return options.filter((cotacao) => {
                                                        const cotacaoText = returnDescricaoVeiculo(cotacao).toLowerCase();
                                                        return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                    });
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label=" Veículo " multiline rows={7} />
                                                )}
                                                renderOption={(option) => (
                                                    <div>
                                                        {returnDescricaoVeiculo(option).split('\n').map((line, index) => (
                                                            <Typography key={index}>{line}</Typography>
                                                        ))}
                                                    </div>
                                                )}
                                            />
                                        </Card>
                                    </Grid>
                                </Grid>







                                <Grid
                                    container
                                    direction="row"
                                    item xs={12}
                                    alignItems="center"
                                    justifyContent="center"
                                >

                                    <Grid
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={1}
                                    >
                                        <Grid item xs={12} container alignItems="center"
                                            justifyContent="center">
                                            <Typography variant="h6" sx={{ mb: 1 }}>
                                                ⏰ Período do Agendamento
                                            </Typography>
                                            <Divider sx={{ mb: 2 }} />
                                        </Grid>

                                        <Grid
                                            container
                                            direction="row"
                                            item xs={1}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <TextField
                                                variant="standard"
                                                name="horaInicial"
                                                label="Hora Inicial"
                                                id="horaInicial"
                                                value={horaInicial}
                                                onChange={(e) => setHoraInicial(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid
                                            container
                                            direction="row"
                                            item xs={1}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <TextField
                                                variant="standard"
                                                name="dataInicial"
                                                label="Data Inicial"
                                                id="dataInicial"
                                                value={dataInicial}
                                                onChange={(e) => setDataInicial(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>



                                        <Grid
                                            container
                                            direction="row"
                                            item xs={1}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <TextField
                                                variant="standard"
                                                name="horaFinal"
                                                label="Hora Final"
                                                id="horaFinal"
                                                value={horaFinal}
                                                onChange={(e) => setHoraFinal(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid
                                            container
                                            direction="row"
                                            item xs={1}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <TextField
                                                variant="standard"
                                                name="dataFinal"
                                                label="Data Final"
                                                id="dataFinal"
                                                value={dataFinal}
                                                onChange={(e) => setDataFinal(e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12}>
                                    <TextField
                                        variant="standard"
                                        name="motivo"
                                        label="Motivo"
                                        id="motivo"
                                        value={motivo}
                                        onChange={(e) => setMotivo(e.target.value)}
                                        fullWidth
                                    />
                                </Grid>


                                <Grid item xs={12}>
                                    <TextField
                                        variant="standard"
                                        name="descricao"
                                        label="Descrição"
                                        id="descricao"
                                        value={descricao}
                                        onChange={(e) => setDescricao(e.target.value)}
                                        fullWidth
                                        multiline
                                        minRows={3}
                                    />
                                </Grid>















                            </Grid>





                        </Grid>


                    }


                    <Dialog
                        open={openRemoverColaborador}
                        onClose={handleCloseRemoverColaborador}
                        fullWidth
                        maxWidth="sm"
                        PaperProps={{
                            style: {
                                backgroundColor: darkMode ? '#1e1e1e' : '#fff',
                                color: darkMode ? '#fff' : '#000'
                            }
                        }}
                    >
                        <DialogTitle style={{ color: darkMode ? '#fff' : '#000' }}>Retirar Colaborador do Agendamento</DialogTitle>

                        <DialogContent>
                            <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Grid item xs={12}>
                                    <TextField
                                        label="Motivo da saída"
                                        fullWidth
                                        multiline
                                        minRows={3}
                                        value={motivoSaida}
                                        onChange={(e) => setMotivoSaida(e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        label="Data da saída"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={dataSaida}
                                        onChange={(e) => setDataSaida(e.target.value)}
                                    />
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                    alignItems="center"
                                    item xs={10}
                                >

                                    {
                                        flag === 1 &&
                                        <Button style={{ marginTop: 5 }}
                                            variant="contained"
                                            color="primary"
                                            onClick={removerColaborador}
                                        > Finalizar  </Button>
                                    }

                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>

                </div >
            </CoreThemeProvider>
        </MuiThemeProvider>
    );
}


